<div class="oauth-consent-container">
  <div class="consent-card">
    <div class="consent-header">
      <div class="logo-container">
        <img
          [src]="imageUrl('login-page-assets/logo-bg-white.svg')"
          alt="Maids-cc logo"
          class="consent-logo"
        />
      </div>
      <h1 class="consent-title">Authorize Application</h1>
      <p class="consent-subtitle" *ngIf="viewState === 'ready' && metadata">
        <strong>{{ metadata.clientName }}</strong> is requesting access to your account.
      </p>
    </div>

    <div class="consent-body" *ngIf="viewState === 'loading'">
      <p class="status-message">Loading authorization details...</p>
    </div>

    <div class="consent-body" *ngIf="viewState === 'ready' && metadata">
      <h2 class="scopes-title">Requested permissions</h2>
      <ul class="scope-list" *ngIf="metadata.scopes?.length; else noScopes">
        <li class="scope-item" *ngFor="let scope of metadata.scopes">
          <span class="scope-name">{{ scope.label || scope.name }}</span>
          <span class="scope-description" *ngIf="scope.description">
            {{ scope.description }}
          </span>
        </li>
      </ul>
      <ng-template #noScopes>
        <p class="status-message">No additional permissions were requested.</p>
      </ng-template>

      <div class="consent-actions">
        <button
          type="button"
          class="consent-btn consent-btn-deny"
          (click)="denyAccess()"
        >
          Deny
        </button>
        <button
          type="button"
          class="consent-btn consent-btn-allow"
          (click)="allowAccess()"
        >
          Allow
        </button>
      </div>
    </div>

    <div class="consent-body" *ngIf="viewState === 'submitting'">
      <p class="status-message">Completing authorization...</p>
    </div>

    <div class="consent-body consent-error" *ngIf="viewState === 'error'">
      <p class="error-message">{{ errorMessage }}</p>
      <button type="button" class="consent-btn consent-btn-cancel" (click)="cancel()">
        Back to login
      </button>
    </div>
  </div>
</div>
